import Segmented from 'antd/es/segmented';
export default Segmented;
